import { Component, Input } from '@angular/core';
import { DocumentBlockDTO } from '@models/image-block';
import { HttpClient } from '@angular/common/http';
import { ModalService } from '@core/services/modal.service';

@Component({
  selector: 'app-document-block-viewer',
  styleUrls: ['./document-block-viewer.component.scss'],
  template: `
      <div class="col justify-center align-items-centered">
        <a
          class="picture-area"
          mat-button
          target="_blank"
          [href]="block?.file?.cdnUrl"
          [matTooltip]="'View ' + block?.file?.fileName"
          matTooltipPosition="above"
        >
          <img class="w-100"
            [src]="getThumbnailUrl()"
            alt="Thumbnail of downloadable document"
          />
        </a>
        <div class="row">
          <button
            class="sub-area-1"
            mat-button
            (click)="downloadDocument()"
            [matTooltip]="'Download ' + block?.file?.fileName"
            matTooltipPosition="above"
          >
            <img
              class="download-icon"
              src="assets/img/download.png"
              alt="google download icon image"
            />
          </button>
          <button
            *ngIf="isPdf()"
            class="sub-area-2"
            mat-button
            color="primary"
            (click)="openReaderDialog()"
          >
            <img
              class="download-icon"
              src="assets/img/open_book.png"
              alt="google open book icon image"
            />
          </button>
        </div>
      </div>
  `,
})
export class DocumentBlockViewer {
  @Input() block: DocumentBlockDTO = new DocumentBlockDTO();

  constructor(private http: HttpClient, private modalService: ModalService) {}

  public downloadDocument(): void {
    this.http
      .get(this.block?.file?.signedUrl, { responseType: 'blob' })
      .subscribe((pdfFile: Blob) => {
        const downloadURL = URL.createObjectURL(pdfFile);
        const link = document.createElement('a');
        link.href = downloadURL;
        link.download = this.block.file.fileName;
        link.click();
      });
  }

  public openReaderDialog(): void {
    this.modalService
      .openPagerDialog(this.block.file)
      .subscribe((result) => {});
  }

  public getThumbnailUrl(): string {
    if (this.isImage()) {
      return this.block?.file?.cdnUrl;
    }
    return this.block?.thumbnail?.cdnUrl || '';
  }

  private isImage(): boolean {
    return this.block?.file?.fileMimeType?.startsWith('image/') ?? false;
  }

  public isPdf(): boolean {
    return this.block?.file?.fileMimeType?.startsWith('application/pdf') ?? false;
  }
}
